import React from "react";

import HindcastsTable from "./HindcastsTable";

import CenteredLoading from "../../common/CenteredLoading";
import { List, ListItemText, ListSubheader } from "@material-ui/core";

const HindcastsTablePanel = (props) => {
    const { data, loading, failedParameters, selectedPercentile } = props;

    return !loading ? (
        <>
            <div
                style={{
                    display: "flex",
                    flex: "1 1 auto",
                    flexDirection: "row",
                    backgroundColor: "white",
                    justifyContent: "flex-start",
                    alignContent: "flex-start",
                    alignItems: "flex-start",
                    height: "fit-content",
                    maxHeight: "800px",
                }}
            >
                <HindcastsTable
                    data={data}
                    selectedPercentile={selectedPercentile}
                ></HindcastsTable>
            </div>

            {failedParameters.length > 0 && (
                <div style={{ padding: "16px" }}>
                    <List
                        dense
                        disablePadding
                        subheader={
                            <ListSubheader
                                style={{ color: "red" }}
                                disablePadding
                            >
                                No data was available for following parameters:
                            </ListSubheader>
                        }
                    >
                        {failedParameters.map((fp) => {
                            return (
                                <ListItemText
                                    key={fp}
                                    primary={fp}
                                    style={{ marginLeft: 32 }}
                                ></ListItemText>
                            );
                        })}
                    </List>
                </div>
            )}
        </>
    ) : (
        <CenteredLoading style={{ position: "relative" }} />
    );
};

export default HindcastsTablePanel;
